import { useState, useEffect } from "react";
import { toast } from "sonner";
import { School as SchoolIcon } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function SchoolInfoDialog({ open, onOpenChange, initial, onConfirm, confirmLabel = "Generate report", description }) {
  const [name, setName] = useState(initial?.name || "");
  const [udise, setUdise] = useState(initial?.udise || "");

  useEffect(() => {
    if (open) {
      setName(initial?.name || "");
      setUdise(initial?.udise || "");
    }
  }, [open, initial]);

  const submit = (e) => {
    e?.preventDefault();
    if (!name.trim()) { toast.error("School name is required"); return; }
    if (!udise.trim()) { toast.error("UDISE code is required"); return; }
    if (!/^\d{11}$/.test(udise.trim())) { toast.error("UDISE code must be exactly 11 digits"); return; }
    onConfirm({ name: name.trim(), udise: udise.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="school-info-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display">
            <span className="h-8 w-8 rounded-lg bg-emerald-700 text-white grid place-items-center"><SchoolIcon size={16}/></span>
            School details for the report
          </DialogTitle>
          <DialogDescription>
            {description || "These will appear on the letterhead of the PDF. They're saved on this device for next time."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="dlg-school-name" className="text-sm font-semibold">School name *</Label>
            <Input id="dlg-school-name" value={name} onChange={(e) => setName(e.target.value)}
                   className="h-11 mt-1.5" placeholder="e.g. Govt. UP School, Bhubaneswar"
                   data-testid="dialog-school-name" autoFocus/>
          </div>
          <div>
            <Label htmlFor="dlg-udise" className="text-sm font-semibold">UDISE code *</Label>
            <Input id="dlg-udise" value={udise} onChange={(e) => setUdise(e.target.value.replace(/\D/g, "").slice(0, 11))}
                   className="h-11 mt-1.5" placeholder="11-digit UDISE (e.g. 21010100999)" inputMode="numeric" maxLength={11}
                   data-testid="dialog-udise"/>
          </div>
        </form>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="dialog-cancel-btn">Cancel</Button>
          <Button onClick={submit} className="bg-emerald-700 hover:bg-emerald-800 text-white" data-testid="dialog-confirm-btn">
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
